import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { createApiClient } from './api/http';
import { createIamTokenProvider } from './auth/session';
import { createAuthRepository } from './auth/types';
import { publicEnvironment } from './config/environment';
import { createAppRouter } from './routes/router';
import '@fontsource-variable/inter';
import '@fontsource/ibm-plex-sans-thai/thai-400.css';
import '@fontsource/ibm-plex-sans-thai/thai-500.css';
import '@fontsource/ibm-plex-sans-thai/thai-600.css';
import '@fontsource/ibm-plex-sans-thai/thai-700.css';
import './styles.css';

const ssoConfiguration = Object.freeze({
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  applicationId: import.meta.env.VITE_SSO_APPLICATION_ID,
  iamApiBaseUrl: import.meta.env.VITE_SSO_API_BASE_URL,
  iamPortalUrl: import.meta.env.VITE_IAM_PORTAL_URL,
});
const tokenProvider = createIamTokenProvider(ssoConfiguration);
const apiClient = createApiClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  getAccessToken: () => tokenProvider.getIdToken(),
});
const authRepository = createAuthRepository(apiClient);
const router = createAppRouter({
  apiClient,
  buildSha: import.meta.env.VITE_BUILD_SHA,
  environment: publicEnvironment,
  environmentLabel: import.meta.env.VITE_ENVIRONMENT_LABEL,
  version: import.meta.env.VITE_APP_VERSION,
});

const rootElement = document.getElementById('root');
if (rootElement === null) throw new Error('Backoffice root element is missing');

createRoot(rootElement).render(
  <StrictMode>
    <App
      authRepository={authRepository}
      environment={publicEnvironment}
      router={router}
      tokenProvider={tokenProvider}
    />
  </StrictMode>,
);
